import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../../constants/Styles";
import styled from "styled-components";

export const PART_SEARCH_DRAWER_WIDTH = "550px";
export const INVENTORY_DRAWER_WIDTH = "100%";

export const MainContainer = styled.div`
  width: 100%;
  height: 100vh;
  padding: 1rem 2rem 2rem 3rem;
  background-color: ${COLORS.background};
  overflow-y: scroll;
`;

export const TopLineContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
`;

export const TitleAndImageContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  word-break: break-word;
  margin-bottom: 2rem;
`;

export const PartDetailText = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size13};
`;

export const PartName = styled.div`
  font-size: ${FONT_SIZE.size24};
  font-weight: ${FONT_WEIGHT.weight500};
`;

export const TitleText = styled.div`
  font-size: ${FONT_SIZE.size18};
  font-weight: ${FONT_WEIGHT.weight500};
`;

export const ApproveSellerContainer = styled.div`
  background-color: ${COLORS.badgeGray};
  border-radius: 0.5rem;
  padding: 1rem;
  margin-top: 1rem;
`;
